import React from 'react';
import { useTranslation } from 'react-i18next';
import SaasSection from '../saas/Section';
import SaasContainer from '../saas/Container';
import SaasButton from '../saas/Button';
import Reveal from '../saas/Reveal';
import { SmallBusinessPillars } from './SmallBusinessPillars';
import LandingCollageScene from './LandingCollageScene';
import LandingCollageCard from './LandingCollageCard';

const SmallBusinessSolutionSection = () => {
  const { t } = useTranslation();
  const pillars = [t('smallBusiness.item1'), t('smallBusiness.item2'), t('smallBusiness.item3')];

  return (
    <SaasSection variant="wash" className="relative overflow-x-hidden">
      <div
        className="pointer-events-none absolute inset-x-0 bottom-0 h-[min(45vh,420px)] bg-[radial-gradient(ellipse_80%_55%_at_50%_100%,rgba(113,75,103,0.08)_0%,transparent_65%)]"
        aria-hidden
      />
      <SaasContainer className="relative">
        <div className="grid grid-cols-1 items-center gap-10 md:grid-cols-2 md:gap-12 lg:gap-16">
          <Reveal className="order-2 md:order-1">
            <LandingCollageCard
              glow={
                <div
                  className="pointer-events-none absolute -bottom-12 start-[12%] h-44 w-44 rounded-full bg-amber-tag/12 blur-3xl"
                  aria-hidden
                />
              }
            >
              <LandingCollageScene variant="smb" embedded />
            </LandingCollageCard>
          </Reveal>

          <div className="order-1 space-y-7 text-center md:order-2 md:space-y-8">
            <div className="mx-auto flex w-full max-w-2xl flex-col items-center text-center">
              <Reveal>
                <p className="type-eyebrow mb-3">{t('smallBusiness.eyebrow', { defaultValue: 'راه‌حل SMB' })}</p>
                <span
                  className="mb-4 inline-block h-1.5 w-14 rounded-full bg-gradient-to-r from-amber-tag/90 via-signal/60 to-coral-alert/50 md:mb-5"
                  aria-hidden
                />
              </Reveal>
              <Reveal delayMs={40}>
                <h2 className="type-section-title text-balance text-2xl md:text-heading-lg">
                  {t('smallBusiness.title')}
                </h2>
              </Reveal>
            </div>
            <Reveal delayMs={60}>
              <p className="type-lead mx-auto max-w-xl md:text-lg">
                {t('smallBusiness.description')}
              </p>
            </Reveal>
            <div className="mx-auto w-full max-w-xl md:max-w-2xl">
              <SmallBusinessPillars items={pillars} />
            </div>
            <Reveal delayMs={120} className="flex flex-wrap justify-center gap-3 pt-1">
              <SaasButton to="/join" variant="gradient" className="min-w-[9.5rem] justify-center">
                {t('smallBusiness.register')}
              </SaasButton>
              <SaasButton to="/about" variant="ghost" className="min-w-[9.5rem] justify-center border-hairline/60">
                {t('smallBusiness.about')}
              </SaasButton>
            </Reveal>
          </div>
        </div>
      </SaasContainer>
    </SaasSection>
  );
};

export default SmallBusinessSolutionSection;
